import type {
  CreditLedgerEntry,
  CreditLedgerReason,
} from "@/providers/credits.provider";

export const CREDIT_REASON_LABELS: Record<CreditLedgerReason, string> = {
  signup: "Referral bonus",
  store_purchase: "Store purchase",
  event_create: "Event created",
  event_boost: "Event boosted",
  admin_adjust: "Admin adjustment",
};

// The ledger launched with one synthetic admin_adjust per existing balance,
// carrying this note and no actor. It records the launch balance, not a real
// admin action.
const BACKFILL_NOTE = "admin_adjusted";

export function isStartingBalance(entry: CreditLedgerEntry) {
  return (
    entry.reason === "admin_adjust" &&
    entry.actor_user_id === null &&
    entry.note === BACKFILL_NOTE
  );
}

export function ledgerEntryLabel(entry: CreditLedgerEntry) {
  if (isStartingBalance(entry)) return "Starting balance";
  return CREDIT_REASON_LABELS[entry.reason] ?? entry.reason;
}

/** What ref_id points at for this entry, or null when it has none. */
export function ledgerRefLabel(entry: CreditLedgerEntry) {
  if (!entry.ref_id) return null;
  switch (entry.reason) {
    case "signup":
      return "Referrer";
    case "event_create":
    case "event_boost":
      return "Event";
    case "admin_adjust":
      return "Club";
    default:
      return "Ref";
  }
}
